import { GetWalletResponse } from '@aaa-ncnu-ie/mypolicy-api-billing';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from '../axios';

export const getWallet = async (ownerId: string) => {
  if (!ownerId) {
    throw new Error('Missing ownerId');
  }

  const requestBody = {
    ownerID: ownerId,
  };

  const { data } = await axios.post<GetWalletResponse>(
    `${
      import.meta.env.VITE_MYPOLICY_BILLING_API_URL
    }/v1/wallet/retrieveByOwnerId`,
    requestBody,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  return data;
};

export const useWalletQuery = (ownerId: string) =>
  useQuery({
    queryKey: ['wallet'],
    queryFn: () => getWallet(ownerId),
    enabled: !!ownerId,
    retry: false,
    staleTime: 1000 * 60 * 5,
  });
